import { c as _c } from "react/compiler-runtime";
import { Popover, transformSecondsToHoursAndMinutes } from '@systemeio/ui';
import { FUNNEL_EMAIL_API, deleteFunnelEmail } from 'modules/funnels/funnel/components/email-tab/api/funnel-email-api';
import FunnelEmailUpdate from 'modules/funnels/funnel/components/email-tab/funnel-email-update';
import { FunnelEmailsApiInterface, FunnelEmailsInterface } from 'modules/funnels/funnel/components/email-tab/types/funnel-emails-interface';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import React from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { convertSecondsToTimeValue } from 'shared/components/date-picker/time-delay-picker/utils';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import { LimitType, PaginationInterface } from 'shared/types/pagination-interface';
import { KeyedMutator } from 'swr';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
interface FunnelEmailTableProps {
  emails?: FunnelEmailsApiInterface;
  funnelStepId?: FunnelStepId;
  setPagination: React.Dispatch<React.SetStateAction<PaginationInterface>>;
  setLimit: React.Dispatch<React.SetStateAction<LimitType>>;
  limit: LimitType;
  pagination: PaginationInterface;
  mutateEmails: KeyedMutator<FunnelEmailsApiInterface>;
}
const FunnelEmailTable = t0 => {
  const $ = _c(54);
  const {
    emails,
    funnelStepId,
    setPagination,
    setLimit,
    limit,
    pagination,
    mutateEmails
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails`;
  let t2;
  if ($[0] !== setPagination || $[1] !== t1) {
    t2 = {
      api: t1,
      setPagination
    };
    $[0] = setPagination;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateData = useUpdateData(t2);
  let t3;
  if ($[3] !== emails || $[4] !== updateData) {
    t3 = async email => {
      await deleteFunnelEmail(email.webinarNotification.id);
      await updateData(false, emails);
    };
    $[3] = emails;
    $[4] = updateData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const deleteEmail = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t("global.event_caption");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = email_0 => {
      const time = transformSecondsToHoursAndMinutes(email_0.webinarNotification.certainTime);
      const delay = convertSecondsToTimeValue(email_0.webinarNotification.delay);
      return <div className="flex gap-2"><Popover label={<div className="flex flex-col items-start">{delay && <span>{t("dashboard.funnel.emails_webinar.delay")}:{" "}{`${delay.timeValue} ${t(delay.name)}`}</span>}{email_0.webinarNotification.certainTime && <span className="pb-2">{t("dashboard.funnel.emails_webinar.certain_time")}: {time.hours}:{time.minutes}</span>}<span>{t("dashboard.funnel.emails_webinar.number_of_sent_emails")}:{" "}{email_0.mailingStats.sentAmount}</span><span>{t("dashboard.funnel.emails_webinar.opened_emails")}:{" "}{email_0.mailingStats.openedAmount}</span><span>{t("dashboard.funnel.emails_webinar.count_of_click")}:{" "}{email_0.mailingStats.clickedAmount}</span></div>}>{_temp}</Popover><div className="truncate"><span className="w-full">{email_0.webinarNotification.event === "webinar_start" ? email_0.webinarNotification.delay < 0 ? `${t("dashboard.funnel.emails_webinar_start_before")} ` : `${t("dashboard.funnel.emails_webinar_start_after")} ` : ""}{t(`dashboard.funnel.emails_${email_0.webinarNotification.event}`)}</span></div></div>;
    };
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = {
      key: "mailingStats",
      header: t4,
      widthPercent: 73,
      onRender: t5
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("global.title_caption");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      key: "webinarNotification",
      header: t7,
      widthPercent: 73,
      onRender: _temp2
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = [t6, t8];
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const columns = t9;
  let t10;
  if ($[20] !== t) {
    t10 = t("dashboard.funnel.title");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== limit || $[23] !== setLimit) {
    t11 = {
      limit,
      setLimit
    };
    $[22] = limit;
    $[23] = setLimit;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== pagination || $[26] !== setPagination) {
    t12 = {
      pagination,
      setPagination
    };
    $[25] = pagination;
    $[26] = setPagination;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("dashboard.funnel.emails_webinar.edit_send_email");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== funnelStepId || $[31] !== mutateEmails) {
    t14 = (opened, onClose, instance) => <FunnelEmailUpdate opened={opened} onClose={onClose} instance={instance} funnelStepId={funnelStepId} mutateEmails={mutateEmails} />;
    $[30] = funnelStepId;
    $[31] = mutateEmails;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = {
      name: "edit-send-email",
      caption: t13,
      onActionRender: t14
    };
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("dashboard.funnel.emails_webinar.remove_email");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== deleteEmail || $[39] !== t) {
    t17 = (opened_0, onClose_0, instance_0, key) => <ConfirmationModal key={key} toastCaption={t("dashboard.funnel.emails_webinar.email_delete_success")} confirmationText={t("dashboard.funnel.emails_webinar.modal_delete_confirm")} opened={opened_0} onClose={onClose_0} onConfirm={() => deleteEmail(instance_0)} />;
    $[38] = deleteEmail;
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t16 || $[42] !== t17) {
    t18 = {
      name: "delete-email",
      caption: t16,
      onActionRender: t17
    };
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t15 || $[45] !== t18) {
    t19 = {
      custom: [t15, t18]
    };
    $[44] = t15;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== columns || $[48] !== emails || $[49] !== t10 || $[50] !== t11 || $[51] !== t12 || $[52] !== t19) {
    t20 = <Table data={emails} nestedId="webinarNotification" columns={columns} caption={t10} limiter={t11} paginator={t12} testAttributePostfix="emails" actions={t19} />;
    $[47] = columns;
    $[48] = emails;
    $[49] = t10;
    $[50] = t11;
    $[51] = t12;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  return t20;
};
export default FunnelEmailTable;
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp2(email_1) {
  return <div className="truncate"><span className="w-full">{email_1.webinarNotification.mailing.currentEmail.subject}</span></div>;
}